import React from 'react';
import cn from 'classnames';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import { Section } from '@wix/da-a11y/pkg/components/headings/tagWrappers';
import Timestamp from '../../../Timestamp';
import s from './Poll.scss';
const MAX_QUESTION_LENGTH = 55;
const PollInlineView = (props)=>{
    const { deviation, width, height } = props;
    const { poll } = deviation;
    const questionTruncated = (poll === null || poll === void 0 ? void 0 : poll.question) && poll.question.length > MAX_QUESTION_LENGTH ? `${poll.question.slice(0, MAX_QUESTION_LENGTH)}...` : poll === null || poll === void 0 ? void 0 : poll.question;
    const isSmall = (height !== null && height !== void 0 ? height : 0) <= 150;
    return /*#__PURE__*/ React.createElement("div", {
        className: cn(s['root'], isSmall && s['tiny']),
        style: {
            width,
            height
        }
    }, /*#__PURE__*/ React.createElement(Section, null, /*#__PURE__*/ React.createElement(Heading, {
        className: s['question']
    }, questionTruncated), /*#__PURE__*/ React.createElement("div", {
        className: s['info']
    }, /*#__PURE__*/ React.createElement("span", {
        className: s['date']
    }, /*#__PURE__*/ React.createElement(Timestamp, {
        timestamp: poll === null || poll === void 0 ? void 0 : poll.ts
    })), "  |  ", /*#__PURE__*/ React.createElement("span", {
        className: s['vote-count']
    }, poll === null || poll === void 0 ? void 0 : poll.votes, " votes"))));
};
PollInlineView.displayName = 'PollInlineView';
export default PollInlineView;

//# sourceMappingURL=Poll.js.map